module.exports = __webpack_public_path__ + "static/media/personBlack.53241f01.svg";